import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClient } from "../../entity/EntityClient";

export class DtoClientsGetRes extends EntityClient {
  public items: EntityClient[]  = [];
}
